import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map, Set } from 'immutable';

import { TimelineItemEntity } from './timeline-item.entity';

export interface ITimelineListExtra
	extends IListColumnConfig<TimelineItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface ITimelineListEntity extends IListAttrs<TimelineItemEntity> {
	availableColumns: Map<string, ITimelineListExtra>;
}

const entityDefaults: ITimelineListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class TimelineListEntity
	implements
		ITimelineListEntity,
		IListOperations<TimelineListEntity, TimelineItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(
		availableCols: Array<ITimelineListExtra>
	): TimelineListEntity {
		const instance = new TimelineListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, ITimelineListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<
		string,
		IListColumnConfig<TimelineItemEntity>
	> {
		return this.availableColumns;
	}

	public setElements(
		elems: Map<string, TimelineItemEntity>
	): TimelineListEntity {
		return produce(this, (draft: TimelineListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, timelineItem) => {
			if (!timelineItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...timelineItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>(startValues));
	}

	public extractModifiers(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, timelineItem) => {
			if (timelineItem.updatedByAvatar && timelineItem.updatedByAvatar?.name) {
				acc = acc.add(timelineItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}

	public extractActionCreators(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, timelineItem) => {
			if (timelineItem.createdByAvatar && timelineItem.createdByAvatar.name) {
				acc = acc.add(timelineItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}
}
